import { organizationsNames } from "@/container/Organizations/organizationsNames";

export const FeatureNames = {
  CONNECTORS: "connectors",
  LOOK_BACK_DAYS: "look-back-days",
  MONITOR_DETAILS_ANALYSIS: "monitor_details_analysis",
};

export const FeatureAvailability = {
  [FeatureNames.CONNECTORS]: {
    [organizationsNames.hoya]: true,
    [organizationsNames.averroes]: true,
    [organizationsNames.nagasaka]: true,
    [organizationsNames.abi]: true,
    [organizationsNames.ZeitView]: true,
  },
  [FeatureNames.LOOK_BACK_DAYS]: {
    [organizationsNames.hoya]: false,
    [organizationsNames.averroes]: true,
    [organizationsNames.nagasaka]: true,
  },
  [FeatureNames.MONITOR_DETAILS_ANALYSIS]: {
    [organizationsNames.hoya]: true,
    [organizationsNames.averroes]: true,
    [organizationsNames.nagasaka]: false,
  },
};
